import { Spinner } from "react-bootstrap";

const SuspenseSpinner = ({ percent }) => {
    return (
        <div className={`d-flex justify-content-center align-items-center ${percent ? 'mt-5' : ''}`} style={{ minHeight: percent ? `100%` : `100vh`, minWidth: `100%` }}>
            <Spinner animation="border" />
        </div>
    )
}

export default SuspenseSpinner